import React, { useState } from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";

import { useStore } from "../../store";
import { ProfileWidget } from "../profile_widget";

import Language from "../../helpers/language";


//Define the admin header
export const Header = props => {
    const { is_sidebar_open, tenant_uid, tenants, showToast } = props;
    const { onContext } = props;

    const { usr_info } = useStore(state => ({ usr_info: state.usr_info }));
    const { nickname, name, email, role } = usr_info;

    const [state, setState] = useState({
        profile_widget: React.createRef()
    });
    const { profile_widget } = state;

    //Calculate the title
    let title = "Drip7";
    let expires = null
    for (let i = 0; i < tenants.length; i++) {
        if (tenants[i].uid == tenant_uid) {
            title = tenants[i].name;

            if (tenants[i].trial_remaining) {
                if (tenants[i].trial_remaining == 0) {
                    expires = Language.getSentenceCase('last day')
                }
                else {
                    expires = tenants[i].trial_remaining.toString() + ' ' + Language.getSentenceCase('days remaining')
                }
            }
        }
    }

    const tenant_only = tenants.length == 1;

    //Functions
    const showProfile = () => {
        if (profile_widget.current != null) {
            profile_widget.current.toggle();
        }
    };

    return (
        <header className={`admin-header ${is_sidebar_open ? "active" : ""}`}>
            <div className='header-wrap'>
                {false && (<h2>{title}</h2>)}

                <div className='user-mini-profile' onClick={showProfile}>
                    <div className='user-mini-info'>
                        <h3 className='user-name font-semibold'>
                            {nickname || name || email}
                        </h3>
                        <p className='user-title font-semibold'>
                            {Language.getTitleCase(role)}
                        </p>
                    </div>
                    <i className='drop-chevron'></i>
                </div>

                <ProfileWidget
                    ref={profile_widget}
                    switch_to='client'
                    showToast={showToast}
                />

                {!tenant_only && (
                    <DropdownButton title={title} className="no-border">
                        {Object.entries(tenants).map(([key, tenant]) => (
                            <Dropdown.Item
                                as='button'
                                onClick={e => onContext(e.target.id)}
                                id={tenant.uid}
                                
                                key={"header_tenant_dropdown_" + key}>
                                {tenant.name}
                            </Dropdown.Item>
                        ))}
                    </DropdownButton>
                )}
                {expires &&
                    <span>{Language.getSentenceCase('trial')}: {expires}</span>
                }
            </div>
        </header>
    );
};
